import { Box, Grid } from '@mui/material';
import GeneralDataItem from 'src/components/GeneralDataItem';
import Subtitle from 'src/components/Subtitle';
import { DebenturesResumeData } from 'src/types/operations/debentures';

type OperationDebenturesResumeGeneralDataProps = {
  data?: Pick<
    DebenturesResumeData['general'],
    'empresa' | 'numeroEmissao' | 'serie'
  >;
};

export default function OperationDebenturesResumeGeneralData({
  data,
}: OperationDebenturesResumeGeneralDataProps) {
  return (
    <Box p={1}>
      <Subtitle title="Dados Gerais" />
      <Box py={2}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <GeneralDataItem
              title="Empresa"
              subtitle={data?.empresa ?? 'N/D'}
            />
          </Grid>
          <Grid item xs={12}>
            <GeneralDataItem
              title="Nº da Emissão"
              subtitle={data?.numeroEmissao ?? 'N/D'}
            />
          </Grid>
          <Grid item xs={12}>
            <GeneralDataItem title="Série" subtitle={data?.serie ?? 'N/D'} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
